export const center_app_version = {"commit_sha": "38670f98"}
